<ng-template #modalTemplate>
  <div class="modal is-active">
    <div
      class="modal-background"
      (click)="backgroundCanClose ? closeClick() : null"></div>

    @if (isCard) {
      <div
        class="modal-card box is-elevation-1"
        [style.width]="rawWidth ? rawWidth : width + 'px'"
        [style.height]="rawHeight ? rawHeight : 'auto'"
        [style.max-height]="rawHeight ? rawHeight : 'calc(100vh - 200px)'">
        <header
          class="modal-card-head"
          [class.no-border]="noHeaderBorder"
          [class.full-width]="headerIsFullWidth">
          <ng-content select=".modal-header"></ng-content>
        </header>
        <section
          class="modal-card-body"
          [class.no-body-padding]="noBodyPadding"
          (scroll)="bodyScroll()">
          <ng-content select=".modal-body"></ng-content>
        </section>
        @if (!hideFooter) {
          <footer class="modal-card-foot">
            <ng-content select=".modal-footer"></ng-content>
          </footer>
        }

        @if (showLoadingOverlay) {
          <div class="loading-overlay">
            @if (loadingMessage) {
              <span class="loading-message">{{ loadingMessage }}</span>
            }
          </div>
        }
      </div>
    } @else {
      <div
        class="modal-content box is-elevation-1"
        [style.width.px]="width"
        [style.background-color]="backgroundColor"
        [style.border-radius.px]="12">
        <ng-content></ng-content>

        @if (showLoadingOverlay) {
          <div class="loading-overlay"></div>
        }
      </div>
    }
  </div>
</ng-template>
